import { render } from "./MapFields.vue?vue&type=template&id=37533df8"
import script from "./MapFields.vue?vue&type=script&lang=js"
export * from "./MapFields.vue?vue&type=script&lang=js"
script.render = render

export default script